module.exports = __webpack_public_path__ + "static/media/brainIconBlack.a717aa64.png";